import 'css-chunksrc/client/scenes/organizationalUnitRemoval/styles.scss';export default {
  "header": "_header_82cz1_1",
  "main": "_main_82cz1_5",
  "group": "_group_82cz1_12",
  "text": "_text_82cz1_16",
  "buttons": "_buttons_82cz1_21"
};